import React, { useRef, useEffect, useState } from "react";
import images from "../../../images";
import Counter from "../../../components/common/Counter/Counter";
import {
  useGetListBusinessLocationQuery,
  usePostAIGenInfoMutation,
  usePostFileUploadMutation,
} from "../../../services/apiSlice";
import { CheckboxCommon } from "../../../components/common/CheckBox/CheckboxCommon";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import Button from "../../../components/common/Button/Button";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import { useDispatch, useSelector } from "react-redux";
import {
  setLocations,
  removeLocation,
  setDescription,
  setRequirement,
  setExpiryDate,
  setStartDate,
  setThumbnails,
  setQuestName,
} from "./../../../redux/featuresSlice/commonSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import QuestTypeSelect from "../../../components/Quest/QuestTypeSelect";

const StepLocation = ({
  objectiveName,
  shopperCount,
  setShopperCount,
  totalCost,
  isBackNavigation,
  questType,
  setQuestType,
  // setIsBackNavigation,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const queryParams = new URLSearchParams(location.search);
  const addLocationModalRef = useRef();

  const [state, setState] = useState({
    requirementAI: "",
    descriptionAI: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [tempLocations, setTempLocations] = useState([]);
  const [error, setError] = useState("");
  const [questTypeError, setQuestTypeError] = useState("");
  const initialized = useRef(false);
  const aiInitialized = useRef(false); // New ref for AI initialization
  // const aiCallAttempts = useRef(0);

  const reduxLocations = useSelector(
    (state) => state.common?.locationList || []
  );
  const { objectiveNameRedux } = useSelector((state) => state.common);
  const reduxDescription = useSelector(
    (state) => state.common?.description || ""
  );
  const reduxRequirement = useSelector(
    (state) => state.common?.requirement || ""
  );
  const reduxExpiryDate = useSelector((state) => state.common?.expiryDate);
  const reduxStartDate = useSelector((state) => state.common?.startDate);
  const thumbnails = useSelector((state) => state.common?.thumbnails || []);
  const reduxQuestName = useSelector((state) => state.common?.questName || "");

  const getCurrentDateTime = () => {
    return new Date().toLocaleString("sv").replace(" ", "T").slice(0, 16);
  };

  const getDefaultStartDate = () => {
    const now = new Date();
    now.setHours(now.getHours() + 1);
    return now.toLocaleString("sv").replace(" ", "T").slice(0, 16);
  };

  const getDefaultExpiryDate = (startDate) => {
    const start = new Date(startDate);
    start.setDate(start.getDate() + 1);
    return start.toLocaleString("sv").replace(" ", "T").slice(0, 16);
  };

  const getMaxExpiryDate = () => {
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 1);
    return maxDate.toLocaleString("sv").replace(" ", "T").slice(0, 16);
  };

  const addOneHour = (dateString) => {
    const date = new Date(dateString);
    date.setHours(date.getHours() + 1);
    return date.toLocaleString("sv").replace(" ", "T").slice(0, 16);
  };

  const startDate = reduxStartDate || getDefaultStartDate();
  const expiryDate = reduxExpiryDate || getDefaultExpiryDate(startDate);
  const { data: locationListData, isLoading: isLoadingLocationListData } =
    useGetListBusinessLocationQuery();
  const [aiGenInfo, { isLoading: aigen }] = usePostAIGenInfoMutation();
  const [postFileUpload, { isLoading: isUploading }] =
    usePostFileUploadMutation();
  const [uploadError, setUploadError] = useState(null);

  const participantId = "some-participant-id";

  const validateQuestType = (type) => {
    if (!type) {
      setQuestTypeError(t("quest.questType.required"));
      return false;
    }
    setQuestTypeError("");
    return true;
  };

  const handleQuestTypeChange = (selectedType) => {
    setQuestType(selectedType);
    validateQuestType(selectedType);
  };

  useEffect(() => {
    if (locationListData?.data) {
      if (locationListData.data.length === 0) {
        setError(t("quest.pleaseAddLocationInYourProfile"));
      } else {
        setError("");
        if (reduxLocations.length === 0 && !initialized.current) {
          dispatch(
            setLocations(
              locationListData.data.map((loc) => ({ ...loc, checked: true }))
            )
          );
          initialized.current = true;
        }
      }
    }
  }, [locationListData, reduxLocations.length, dispatch, t]);

  // Fetch AI-generated info

  useEffect(() => {
    if (isBackNavigation) {
      return;
    }

    if (!objectiveName && !objectiveNameRedux) return;

    const fetchAIInfo = async () => {
      try {
        const body = { name_quest: objectiveName || objectiveNameRedux };
        const response = await aiGenInfo(body).unwrap();

        if (
          response.message === "Creation successful" ||
          response.status === 200
        ) {
          const newRequirement = response?.data.requirements || "";
          const newDescription = response?.data.description || "";

          setState((prev) => ({
            ...prev,
            requirementAI: newRequirement,
            descriptionAI: newDescription,
          }));
        }
      } catch (error) {
        toast.error(t("toast.error.failedToFetchAIGenInfo"));
      }
    };

    fetchAIInfo();
  }, [objectiveName, objectiveNameRedux, aiGenInfo, t, isBackNavigation]);

  useEffect(() => {
    if (!aiInitialized.current) {
      if (state.descriptionAI && reduxDescription === "") {
        dispatch(setDescription(state.descriptionAI));
      }
      if (state.requirementAI && reduxRequirement === "") {
        dispatch(setRequirement(state.requirementAI));
      }
      aiInitialized.current = true;
    }

    if (!reduxExpiryDate) {
      const futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + 3);
      const formattedExpiryDate = futureDate
        .toLocaleString("sv")
        .replace(" ", "T");
      dispatch(setExpiryDate(formattedExpiryDate));
    }

    if (!reduxStartDate) {
      const formattedStartDate = new Date()
        .toLocaleString("sv")
        .replace(" ", "T");
      dispatch(setStartDate(formattedStartDate));
    }
  }, [
    state.descriptionAI,
    state.requirementAI,
    reduxExpiryDate,
    reduxStartDate,
    reduxDescription,
    reduxRequirement,
    dispatch,
  ]);

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    setUploadError(null);

    const uploadedPaths = [];
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await postFileUpload({
          formData,
          participant_id: participantId,
        }).unwrap();

        if (response?.data) {
          uploadedPaths.push(response.data);
        } else {
          setUploadError(`${t("profile.noPathReturnedFor")} ${file.name}`);
        }
      } catch (error) {
        setUploadError(
          `${t("profile.uploadFailedFor")} ${file.name}: ${error.message}`
        );
      }
    }

    if (uploadedPaths.length > 0) {
      dispatch(setThumbnails([...thumbnails, ...uploadedPaths]));
    }

    event.target.value = null;
  };

  const handleRemoveImage = (thumbnail) => {
    dispatch(setThumbnails(thumbnails.filter((path) => path !== thumbnail)));
  };

  const handleMinusLocation = (location) => {
    dispatch(removeLocation(location.id));
  };

  const handleCheckboxChange = (checked, location) => {
    if (checked) {
      if (!tempLocations.some((loc) => loc.id === location.id)) {
        setTempLocations((prev) => [
          ...prev,
          {
            id: location.id,
            city: location.city,
            country: location.country,
            address: location.address,
            name: location.name,
          },
        ]);
      }
    } else {
      setTempLocations((prev) => prev.filter((loc) => loc.id !== location.id));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const filteredData = locationListData?.data.filter((location) =>
        (location.name || location.address || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
      const allLocations = filteredData.map((location) => ({
        id: location.id,
        city: location.city,
        country: location.country,
        address: location.address,
        name: location.name,
      }));
      const updatedLocations = [
        ...tempLocations.filter(
          (loc) =>
            !filteredData.some((filteredLoc) => filteredLoc.id === loc.id)
        ),
        ...allLocations,
      ];
      setTempLocations(updatedLocations);
    } else {
      const filteredData = locationListData?.data.filter((location) =>
        (location.name || location.address || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
      const filteredIds = new Set(filteredData.map((loc) => loc.id));
      const updatedLocations = tempLocations.filter(
        (loc) => !filteredIds.has(loc.id)
      );
      setTempLocations(updatedLocations);
    }
  };

  const handleSaveLocationModal = () => {
    dispatch(setLocations(tempLocations));
    addLocationModalRef.current?.closeModal();
  };

  const handleCancelLocationModal = () => {
    setTempLocations([...reduxLocations]);
    addLocationModalRef.current?.closeModal();
  };

  const handleDescriptionChange = (newText) => {
    dispatch(setDescription(newText));
  };

  const handleRequirementChange = (e) => {
    dispatch(setRequirement(e.target.value));
  };

  const handleStartDateChange = (e) => {
    const selectedDate = e.target.value;
    const currentDateTime = new Date(getCurrentDateTime());
    const selectedDateObj = new Date(selectedDate);

    if (selectedDateObj < currentDateTime) {
      toast.error(t("toast.error.startDateBeforeNow"));
      return;
    }

    const newStartDate = addOneHour(selectedDate);
    const newStartDateObj = new Date(newStartDate);

    const minStartDate = new Date();
    minStartDate.setHours(minStartDate.getHours() + 1);
    if (newStartDateObj < minStartDate) {
      toast.error(t("toast.error.startDateBeforeMin"));
      return;
    }

    dispatch(setStartDate(newStartDate));

    const expiryDateObj = new Date(expiryDate);
    if (expiryDateObj < newStartDateObj) {
      const newExpiryDate = new Date(newStartDateObj);
      newExpiryDate.setDate(newExpiryDate.getDate() + 1);
      dispatch(
        setExpiryDate(
          newExpiryDate.toLocaleString("sv").replace(" ", "T").slice(0, 16)
        )
      );
    }
  };

  const handleExpiryDateChange = (e) => {
    const newExpiryDate = e.target.value;
    const startDateObj = new Date(startDate);
    const expiryDateObj = new Date(newExpiryDate);
    const maxExpiryDateObj = new Date(getMaxExpiryDate());

    if (expiryDateObj < startDateObj) {
      toast.error(t("toast.error.expiryDateBeforeStartDate"));
      return;
    }

    if (expiryDateObj > maxExpiryDateObj) {
      toast.error(t("toast.error.expiryDateExceedsMax"));
      return;
    }

    dispatch(setExpiryDate(newExpiryDate));
  };

  const handleQuestNameChange = (newText) => {
    dispatch(setQuestName(newText));
  };

  const filteredLocations = locationListData?.data.filter((location) =>
    (location.name || location.address || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleOpenModal = () => {
    setTempLocations([...reduxLocations]);
    addLocationModalRef.current?.openModal();
  };

  useEffect(() => {
    if (!isBackNavigation) {
      dispatch(setThumbnails([]));
    }
  }, [isBackNavigation, dispatch]);

  const [visibleTooltip, setVisibleTooltip] = useState(null);
  const tooltipRef = useRef(null);

  const handleInfoClick = (type) => {
    setVisibleTooltip((prev) => (prev === type ? null : type));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setVisibleTooltip(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <LoadingCommon
        statusLoading={isLoadingLocationListData || isUploading || aigen}
      />
      <div className="w-full">
        <div className="bg-white rounded-xl p-4 w-full max-w-lg">
          <label className="text-gray-400 text-sm">
            {t("quest.questName")}
          </label>
          <div className="mt-2 bg-white rounded-xl">
            <input
              type="text"
              className="w-full text-gray-900 text-base border-none outline-none rounded-xl p-2"
              placeholder={t("quest.enterQuestName")}
              value={reduxQuestName}
              onChange={(e) => handleQuestNameChange(e.target.value)}
            />
          </div>
        </div>
        <QuestTypeSelect
          value={questType}
          onChange={handleQuestTypeChange}
          error={questTypeError}
        />
        {/* Thumbnail */}
        <div className="bg-white rounded-xl p-4 w-full max-w-lg mt-4">
          <label className="text-gray-400 text-sm">
            {t("quest.thumbnail")}
          </label>
          <div className="mt-2">
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
              id="file-upload"
            />
            <div className="flex gap-2 w-full">
              <label
                htmlFor="file-upload"
                className="bg-gray-100 rounded-xl flex items-center justify-center px-4 py-2 cursor-pointer w-full"
              >
                <span className="text-gray-400 text-sm">
                  {t("base.uploadImage")}
                </span>
              </label>
            </div>
            {uploadError && (
              <p className="text-red-500 text-sm mt-2">{uploadError}</p>
            )}
            {thumbnails.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-2">
                {thumbnails.map((thumbnail, index) => {
                  const imageUrl = `${process.env.REACT_APP_URL_IMAGE}/${thumbnail}`;
                  const fileName =
                    thumbnail.split("/").pop() || `Image ${index + 1}`;
                  return (
                    <div
                      key={`uploaded-${thumbnail}-${index}`}
                      className="relative flex justify-center w-full items-center bg-gray-100 rounded-md px-2 py-1"
                    >
                      <span className="text-gray-600 flex justify-center text-sm truncate max-w-[200px] w-full">
                        <img
                          src={imageUrl}
                          alt={fileName}
                          className="object-cover rounded-md"
                          onError={(e) => {
                            e.target.src = "/fallback-image.jpg";
                          }}
                        />
                      </span>
                      <button
                        onClick={() => handleRemoveImage(thumbnail)}
                        className="ml-2 bg-stone-200 text-gray rounded-full w-5 h-5 flex items-center justify-center absolute top-0 right-0"
                      >
                        ×
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        {/* Description */}
        <div className="bg-white rounded-xl p-4 w-full max-w-lg relative mt-4">
          <label className="text-gray-400 text-sm">
            {t("base.description")}
          </label>
          <textarea
            value={reduxDescription}
            onChange={(e) => handleDescriptionChange(e.target.value)}
            className="mt-2 w-full p-2 text-gray-700 text-base leading-relaxed border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            rows="4"
          />
          <div className="absolute top-4 right-4 text-gray-300">
            <img src={images.GenAIIconGray} alt="" className="w-[22px]" />
          </div>
        </div>
        {/* Requirement */}
        <div className="bg-white rounded-xl p-4 w-full max-w-lg relative mt-4">
          <label className="text-gray-400 text-sm">{t("base.required")}</label>
          <textarea
            value={reduxRequirement}
            onChange={handleRequirementChange}
            className="mt-2 w-full p-2 text-gray-700 text-base leading-relaxed border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            rows="4"
          />
          <div className="absolute top-4 right-4 text-gray-300">
            <img src={images.GenAIIconGray} alt="" className="w-[22px]" />
          </div>
        </div>
        {/* Start Date */}
        <div className="bg-white rounded-xl p-4 w-full max-w-md mt-4">
          <label htmlFor="startDate" className="text-gray-400 text-sm">
            {t("base.startDate")}
          </label>
          <div className="flex items-center justify-between mt-1 p-3">
            <input
              id="startDate"
              type="datetime-local"
              value={startDate}
              onChange={handleStartDateChange}
              min={getCurrentDateTime()}
              className="text-gray-900 text-sm rounded-md p-1 w-full focus:outline-none"
            />
          </div>
        </div>
        {/* Expiry Date */}
        <div className="bg-white rounded-xl p-4 w-full max-w-md mt-4 relative">
          <div className="flex flex-row items-center justify-arround gap-2 ">
            <label htmlFor="expiryDate" className="text-gray-400 text-sm">
              {t("base.expireDate")}
            </label>
            <img
              src={images.InfoCircleIcon}
              alt=""
              className="w-[20px] p-[2px]"
              onClick={() => handleInfoClick("expiryDate")}
            />
          </div>
          <div className="flex items-center justify-between mt-1 p-3">
            <input
              id="expiryDate"
              type="datetime-local"
              value={expiryDate}
              onChange={handleExpiryDateChange}
              min={startDate}
              max={getMaxExpiryDate()}
              className="text-gray-900 text-sm rounded-md p-1 w-full focus:outline-none"
            />
          </div>
          {visibleTooltip === "expiryDate" && (
            <div
              ref={tooltipRef}
              className="absolute z-10 left-0 top-10 w-full p-3 bg-white rounded-md shadow-lg border border-gray-200 text-sm text-gray-700"
            >
              <div className="flex flex-col gap-2">
                <div className="font-semibold text-gray-900">
                  {t("quest.stepLocation.importantNotesExpiryDateTitle")}
                </div>
                <span className="text-gray-600 leading-relaxed">
                  {t("quest.stepLocation.importantNotesExpiryDateContent1")}
                </span>
                <span className="text-gray-600 leading-relaxed">
                  {t("quest.stepLocation.importantNotesExpiryDateContent2")}
                </span>
              </div>
            </div>
          )}
        </div>
        {/* Qualifying Questions */}
        <div className="bg-white rounded-xl p-4 w-full max-w-md mt-4">
          <section
            className={
              error
                ? "mt-4 w-full font-medium text-zinc-800 p-3 border border-solid rounded-md bg-white opacity-50"
                : "mt-4 w-full font-medium text-zinc-800 p-3 border border-solid rounded-md bg-white"
            }
          >
            <div className="flex justify-between items-center w-full whitespace-nowrap text-neutral-500">
              <label className="flex items-center text-sm leading-none">
                <span>{t("base.location")}</span>
              </label>
              <button
                disabled={error}
                onClick={error ? null : handleOpenModal}
                className="flex items-center px-2 py-1.5 text-xs min-h-8 cursor-pointer"
              >
                <img
                  src={images.PlusIconBlack}
                  alt="Add"
                  className="w-[24px]"
                />
              </button>
            </div>
            <ul className="flex flex-col mt-1.5 space-y-1.5 gap-3 list-disc">
              {(reduxLocations || []).map((location, index) => (
                <li
                  key={index}
                  className="px-2.5 py-1.5 gap-1 w-full text-sm rounded-xl flex flex-row justify-between "
                >
                  <div>{location.name ? location.name : location.address}</div>
                  <button
                    onClick={() => handleMinusLocation(location)}
                    className="min-w-[22px]"
                  >
                    <img
                      src={images.MinusCircleIcon}
                      alt=""
                      className="w-[22px]"
                    />
                  </button>
                </li>
              ))}
            </ul>
          </section>
          {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
        {/* Diners */}
        <section className="flex flex-col mt-4 w-full font-medium text-zinc-800 p-3 border border-solid rounded-md gap-4 bg-white">
          <div className="flex justify-between items-center w-full whitespace-nowrap text-neutral-500">
            <h2 className="text-base font-bold text-zinc-800">
              {t("quest.stepLocation.howManyDinersToEngage")}
            </h2>
          </div>
          <Counter value={shopperCount} onChange={setShopperCount} />
          <section className="p-3 text-center rounded-xl border border-solid border-stone-200">
            <h3 className="mb-2 text-sm text-neutral-500">
              {t("quest.stepLocation.totalCost")}
            </h3>
            <p className="text-2xl text-zinc-800">$ {totalCost}</p>
          </section>
        </section>
      </div>

      <CommonModal
        ref={addLocationModalRef}
        title={t("quest.stepLocation.chooseLocation")}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.cancel")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] bg-white border border-solid border-stone-200 text-neutral-500"
              onClick={() => handleCancelLocationModal()}
            />
            <Button
              text={t("base.save")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-indigo-600"
              variant="primary"
              onClick={handleSaveLocationModal}
              disabled={tempLocations.length === 0}
            />
          </>
        )}
      >
        <div className="flex flex-col items-center w-full border border-solid p-2 rounded-md">
          <div className="w-full mb-2">
            <input
              type="text"
              placeholder={
                t("quest.stepLocation.searchPlaceholder") ||
                "Search locations..."
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-600"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex flex-row w-full justify-between items-center mb-2 px-2">
            <div className="flex flex-row gap-2 items-center">
              <CheckboxCommon
                className="rounded-sm"
                checked={
                  filteredLocations?.length > 0 &&
                  filteredLocations.every((loc) =>
                    tempLocations.some((selected) => selected.id === loc.id)
                  )
                }
                onCheckedChange={handleSelectAll}
              />
              <span>{t("quest.stepLocation.selected")}</span>
            </div>
            <span className="mr-2 bg-[#3F54DF] py-1 px-2 text-white rounded-md text-sm">
              {tempLocations.length}
            </span>
          </div>

          <div className="space-y-2 mb-4 w-full max-h-64 overflow-y-auto">
            {(filteredLocations || []).map((location) => (
              <label
                key={location.id}
                className="flex items-start gap-2 p-2 hover:bg-gray-100 rounded-md cursor-pointer"
              >
                <CheckboxCommon
                  className="rounded-sm"
                  checked={tempLocations.some((loc) => loc.id === location.id)}
                  onCheckedChange={(checked) =>
                    handleCheckboxChange(checked, location)
                  }
                  value={location.id}
                />
                <span className="text-sm text-gray-800 items-start">
                  {location.name || location.address}
                </span>
              </label>
            ))}
          </div>
          {tempLocations.length === 0 && (
            <p className="text-xs text-red-500 mt-2">
              {t("quest.stepLocation.pleaseSelectAtLeastaLocation")}
            </p>
          )}
        </div>
      </CommonModal>
    </>
  );
};

export default StepLocation;
